<!-- ======= Menu:start ======= -->
<div class="offcanvas offcanvas-lg offcanvas-top bg-white" data-bs-backdrop="static" tabindex="-1"
  id="staticBackdrop" aria-labelledby="staticBackdropLabel">
  <div class="offcanvas-header py-1 px-4 bg-light">
    <h5 class="offcanvas-title" id="staticBackdropLabel">Menu</h5>
    <button type="button" class="btn btn-outline-dark border-0 px-0" data-bs-dismiss="offcanvas"
      aria-label="Close">
      <i class="bi bi-x-lg lead"></i>
    </button>
  </div>
  <div class="offcanvas-body container-fluid">
    <div class="row align-items-center">
      <div class="col-6 mt-3" *ngFor="let item of navItems;">
        <button class="btn btn-sm btn-outline-primary btn-link" data-bs-dismiss="offcanvas"
          aria-label="Close" [routerLink]="item.link">
          {{item.title}}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ======= Menu:end ======= -->
<!-- ======= Navbar:start ======= -->
<nav class="navbar navbar-expand-lg bg-light fixed-top shadow">
  <div class="container">
    <a class="navbar-brand fw-bold fs-5" href="#">
      <img src="../assets/img/mcgill_logo_title.png" alt="McGill ShangpengSun Lab"
        class="logo me-1">
      Shangpeng Sun
    </a>
    <!-- toggle button for offcanvas -->
    <button id="navbar-toggle-btn" class="btn btn-danger px-2 py-0" type="button"
      data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="staticBackdrop">
      <i class="bi bi-list lead"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item" *ngFor="let item of navItems; let i=index">
          <a class="nav-link ps-5 text-dark" [ngClass]="{selected: selected==i}" aria-current="page"
            [routerLink]="item.link" (click)="selectedNav(i)">{{item.title}}</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<!-- ======= Navbar:end ======= -->
<!-- =========================== -->
<router-outlet></router-outlet>
<!-- =========================== -->

<!-- ------------------- -->

<!-- ------------------- -->



<div id="footer" class="footer bg-dark text-secondary pt-4 pb-3">
  <div class="container">
    <div class="row">
      <div class="col text-center">
        <div class="text-center mb-2">
          <img src="../assets/img/mcgill_logo_title_white.png" alt="McGill ShangpengSun Lab"
            class="logo">
        </div>
        &copy; <span *ngIf="startYear!=currentYear">{{startYear}} -
        </span><span>{{currentYear}}</span> Shangpeng Sun. All rights reserved
      </div>
    </div>
  </div>
</div>